import { render, staticRenderFns } from "./MarketSelector.vue?vue&type=template&id=f9b3845c&"
import script from "./MarketSelector.vue?vue&type=script&lang=js&"
export * from "./MarketSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports